import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      meta: { title: 'Ustawienia' },
      component: () =>
        import(/* webpackChunkName: "basic" */ './views/Basic.vue')
    }
  ]
})
